import { geocoding, config } from "@maptiler/client";

config.apiKey = process.env.REACT_APP_MAPAPIKEY;


export async function geocodeAddress(address) {
  try {
    const result = await geocoding.forward(address, { limit: 1, language: "en" });

    if (!result || !Array.isArray(result.features) || result.features.length === 0) {
      console.warn("Geocoding: no features", address, result);
      return null;
    }

    const feat = result.features[0];

    // Manejo defensivo: puede que la geometría esté en different shape
    const center = feat?.geometry?.center; // MapTiler suele usar geometry.center [lng,lat]
    const coords = feat?.geometry?.coordinates; // fallback por si usas otro endpoint

    if (Array.isArray(center) && center.length >= 2) {
      const [lng, lat] = center;
      return { lat, lng, place_name: feat.place_name || address, raw: feat };
    }

    if (Array.isArray(coords) && coords.length >= 2) {
      const [lng, lat] = coords;
      return { lat, lng, place_name: feat.place_name || address, raw: feat };
    }

    console.warn("Geocoding: no center/coordinates found", address, feat);
    return null;
  } catch (error) {
    console.error("Geocoding error:", error);
    return null;
  }
}